/* Lovey Prints product page — vanilla JS port of the Lovable buy box. */
(function () {
  'use strict';

  // The layout and the section can both reference this file; run once either way.
  if (window.__lpInit) return;
  window.__lpInit = true;

  var root = document.querySelector('[data-lp-buy]');
  if (!root) return;

  var cfg = JSON.parse(document.getElementById('lp-config').textContent);
  var variants = cfg.variants;
  var MAX = cfg.maxPhotos || 6;

  /* ---------- helpers ---------- */
  var $ = function (sel, el) { return (el || root).querySelector(sel); };
  var $$ = function (sel, el) { return Array.prototype.slice.call((el || root).querySelectorAll(sel)); };

  function money(pence) {
    var n = pence / 100;
    return cfg.currencySymbol + (Number.isInteger(n) ? n : n.toFixed(2));
  }

  function track(event) {
    if (!cfg.webhook) return;
    try {
      var payload = JSON.stringify({ event: event, time: new Date().toISOString() });
      if (navigator.sendBeacon) {
        var ok = navigator.sendBeacon(cfg.webhook, new Blob([payload], { type: 'text/plain' }));
        if (ok) return;
      }
      fetch(cfg.webhook, { method: 'POST', headers: { 'Content-Type': 'text/plain' }, body: payload, keepalive: true }).catch(function () {});
    } catch (e) { /* tracking must never break the page */ }
  }

  function findVariant(fmt, size) {
    for (var i = 0; i < variants.length; i++) {
      if (variants[i].format === fmt && (variants[i].size === size || !variants[i].size)) return variants[i];
    }
    return null;
  }
  function minPriceFor(fmt) {
    var m = Infinity;
    variants.forEach(function (v) { if (v.format === fmt && v.price < m) m = v.price; });
    return m === Infinity ? 0 : m;
  }
  function isDigital(fmt) { return /digital/i.test(fmt); }

  /* ---------- state ---------- */
  var params = new URLSearchParams(location.search);
  var state = {
    format: params.get('format') || cfg.defaultFormat,
    size: params.get('size') || cfg.defaultSize
  };
  // Also honour Shopify's ?variant= deep link.
  if (params.get('variant')) {
    var pv = variants.filter(function (v) { return String(v.id) === params.get('variant'); })[0];
    if (pv) { state.format = pv.format; if (pv.size) state.size = pv.size; }
  }

  /* ---------- gallery ---------- */
  var slides = $$('[data-slide]');
  var thumbs = $$('[data-thumb]');
  var stage = $('[data-gallery-stage]');
  var gCount = $('[data-gallery-count]');
  var gIndex = 0;

  function pauseAll() {
    $$('video', stage || document).forEach(function (v) { if (!v.paused) v.pause(); });
  }

  function goTo(i) {
    if (!slides.length) return;
    gIndex = (i + slides.length) % slides.length;   // wraps both ways
    pauseAll();
    slides.forEach(function (sl, n) {
      if (n === gIndex) { sl.removeAttribute('hidden'); } else { sl.setAttribute('hidden', ''); }
    });
    thumbs.forEach(function (b, n) { b.setAttribute('aria-current', String(n === gIndex)); });
    if (gCount) gCount.textContent = (gIndex + 1) + ' / ' + slides.length;
  }

  thumbs.forEach(function (btn, i) {
    btn.addEventListener('click', function () { goTo(i); });
  });

  var prevBtn = $('[data-gallery-prev]');
  var nextBtn = $('[data-gallery-next]');
  if (prevBtn) prevBtn.addEventListener('click', function () { goTo(gIndex - 1); });
  if (nextBtn) nextBtn.addEventListener('click', function () { goTo(gIndex + 1); });

  if (stage) {
    stage.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(gIndex - 1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); goTo(gIndex + 1); }
    });

    // Swipe, but not when the gesture starts on a video's controls.
    var sx = 0, sy = 0, tracking = false;
    stage.addEventListener('touchstart', function (e) {
      if (e.touches.length !== 1) return;
      if (e.target.closest('video, iframe')) { tracking = false; return; }
      sx = e.touches[0].clientX; sy = e.touches[0].clientY; tracking = true;
    }, { passive: true });
    stage.addEventListener('touchend', function (e) {
      if (!tracking) return;
      tracking = false;
      var t = e.changedTouches[0];
      var dx = t.clientX - sx, dy = t.clientY - sy;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.5) goTo(gIndex + (dx < 0 ? 1 : -1));
    }, { passive: true });
  }

  if (slides.length && gCount) gCount.textContent = '1 / ' + slides.length;

  /* ---------- delivery estimate ---------- */
  function fmtDate(d) { return d.toLocaleDateString('en-GB', { weekday: 'short', day: 'numeric', month: 'short' }); }
  function addWorkingDays(from, days) {
    var d = new Date(from), added = 0;
    while (added < days) { d.setDate(d.getDate() + 1); var w = d.getDay(); if (w !== 0 && w !== 6) added++; }
    return d;
  }
  function estimate(digital) {
    var preview = new Date(); preview.setDate(preview.getDate() + 1);
    return { preview: fmtDate(preview), delivery: fmtDate(addWorkingDays(preview, digital ? 1 : 6)) };
  }

  /* ---------- render ---------- */
  function render() {
    var digital = isDigital(state.format);
    var v = findVariant(state.format, state.size);
    // If this format has no such size (e.g. Digital only has one variant), fall back to its first variant.
    if (!v) { v = variants.filter(function (x) { return x.format === state.format; })[0]; if (v && v.size) state.size = v.size; }

    // Format cards
    $$('[data-format]').forEach(function (b) {
      b.setAttribute('aria-checked', String(b.dataset.format === state.format));
    });
    $('[data-format-label]').textContent = state.format;

    // Size buttons
    $$('[data-size]').forEach(function (b) {
      var sv = findVariant(state.format, b.dataset.size);
      b.setAttribute('aria-checked', String(b.dataset.size === state.size));
      b.disabled = !sv || !sv.available;
      $('[data-size-price]', b).textContent = sv ? money(sv.price) : '—';
    });
    $('[data-sizes]').hidden = digital;
    $('[data-digital-note]').hidden = !digital;
    $('[data-size-label]').textContent = digital ? cfg.digitalSizeLabel : (state.size + ' — ' + (cfg.sizeMeta[state.size] ? cfg.sizeMeta[state.size].cm : ''));

    // Price
    if (v) {
      var compare = v.compare_at && v.compare_at > v.price ? v.compare_at : Math.round(v.price * cfg.compareMultiplier);
      $('[data-price]').textContent = money(v.price);
      $('[data-compare]').textContent = money(compare);
      $('[data-save]').textContent = 'Save ' + money(compare - v.price);
      $('[data-cta-price]').textContent = money(v.price);
      $('[data-sticky-price]').textContent = money(v.price);
      $('[data-variant-id]').value = v.id;
    }
    $('[data-shipping-note]').textContent = digital ? cfg.digitalShippingNote : cfg.shippingNote;

    // Estimate
    var est = estimate(digital);
    $('[data-est-preview]').textContent = est.preview;
    $('[data-est-delivery]').innerHTML = digital
      ? cfg.digitalDeliveryText
      : cfg.deliveryText.replace('{date}', '<strong>' + est.delivery + '</strong>');

    // Keep the URL shareable / feed-friendly
    if (v && history.replaceState) {
      var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u);
    }
  }

  $$('[data-format]').forEach(function (b) {
    b.addEventListener('click', function () { state.format = b.dataset.format; render(); track('shop_select_style'); });
  });
  $$('[data-size]').forEach(function (b) {
    b.addEventListener('click', function () { if (b.disabled) return; state.size = b.dataset.size; render(); track('shop_select_size'); });
  });

  /* ---------- submit ---------- */
  var form = $('[data-product-form]');
  var cta = $('[data-cta]');
  form.addEventListener('submit', function (e) {
    if (cta.classList.contains('is-busy')) { e.preventDefault(); return; }
    cta.classList.add('is-busy');
    track('shop_add_to_cart');

    if (cfg.clearCartFirst) {
      e.preventDefault();
      fetch('/cart/clear.js', { method: 'POST' }).catch(function () {}).then(function () {
        track('shop_checkout');
        HTMLFormElement.prototype.submit.call(form); // native multipart POST → /cart/add → return_to
      });
    } else {
      track('shop_checkout');
    }
  });

  /* ---------- sticky mobile bar ---------- */
  var sticky = document.querySelector('[data-sticky]');
  if (sticky && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      sticky.classList.toggle('is-visible', !entries[0].isIntersecting);
      sticky.setAttribute('aria-hidden', String(entries[0].isIntersecting));
    }, { threshold: 0 }).observe(root);
    sticky.querySelector('button').addEventListener('click', function () {
      window.scrollTo({ top: root.getBoundingClientRect().top + window.scrollY - 12, behavior: 'smooth' });
    });
  }

  /* ---------- init ---------- */
  render();
  track('shop_view');
})();

/* Before / after sliders. Separate from the buy box so it runs on any page that uses the section. */
(function () {
  'use strict';
  var sliders = document.querySelectorAll('[data-ba]');
  if (!sliders.length) return;

  Array.prototype.forEach.call(sliders, function (ba) {
    var range = ba.querySelector('[data-ba-range]');
    var stage = ba.querySelector('.lp-ba__stage');
    if (!range || !stage) return;

    function set(v) { ba.style.setProperty('--lp-ba-pos', v + '%'); }
    set(range.value);

    range.addEventListener('input', function () { set(range.value); });

    // Dragging anywhere on the image, not just on the thumb.
    function fromPointer(e) {
      var r = stage.getBoundingClientRect();
      var x = ((e.clientX - r.left) / r.width) * 100;
      range.value = Math.max(0, Math.min(100, x));
      set(range.value);
    }
    stage.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      ba.classList.add('is-dragging');
      stage.setPointerCapture(e.pointerId);
      fromPointer(e);
    });
    stage.addEventListener('pointermove', function (e) {
      if (!ba.classList.contains('is-dragging')) return;
      fromPointer(e);
    });
    ['pointerup', 'pointercancel'].forEach(function (ev) {
      stage.addEventListener(ev, function (e) {
        ba.classList.remove('is-dragging');
        if (stage.hasPointerCapture && stage.hasPointerCapture(e.pointerId)) stage.releasePointerCapture(e.pointerId);
      });
    });
  });
})();

/* Customer video clips. Nothing downloads until the visitor asks for it (preload="none"),
   so three clips cost roughly nothing on load. */
(function () {
  'use strict';
  var clips = document.querySelectorAll('[data-clip]');
  if (!clips.length) return;

  var section = document.getElementById('clips');
  var autoplay = section && section.getAttribute('data-autoplay') === 'true';

  Array.prototype.forEach.call(clips, function (frame) {
    var video = frame.querySelector('[data-clip-video]');
    var play = frame.querySelector('[data-clip-play]');
    var fig = frame.closest('.lp-clip') || frame;
    if (!video) return;

    function start() {
      video.preload = 'auto';
      var p = video.play();
      if (p && p.catch) p.catch(function () { video.controls = true; });
    }

    if (play) {
      play.addEventListener('click', function () {
        // Pause any other clip so two don't talk over each other.
        Array.prototype.forEach.call(clips, function (other) {
          if (other === frame) return;
          var v = other.querySelector('[data-clip-video]');
          if (v && !v.paused) v.pause();
        });
        start();
      });
    }

    video.addEventListener('play', function () { fig.classList.add('is-playing'); });
    video.addEventListener('pause', function () { fig.classList.remove('is-playing'); });
    video.addEventListener('ended', function () { fig.classList.remove('is-playing'); });

    if (autoplay && 'IntersectionObserver' in window) {
      var seen = false;
      new IntersectionObserver(function (entries, obs) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting && !seen) { seen = true; video.muted = true; start(); obs.disconnect(); }
        });
      }, { threshold: 0.4 }).observe(frame);
    }
  });
})();